<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back" />
			<img src="@/images/center_text11.png" class="per_right_1name" />
		</div>
		<div class="per_right_2">
			<div class="news_right_con">
				<el-tabs type="border-card" v-model="activeModel">
					<el-tab-pane label="课程中心" name='first'>
						<div class="noinfo" v-if='mooclist.length<=0'>暂无收藏</div>
						<div v-for="(item,index) in mooclist">
							<div class="table-wrap single">
								<div class="questionTitle questionTitle_only">
									{{index+1}}、{{item.name}}
									<span style="margin-left:50px;font-weight:normal">收藏时间:{{item.createTime}}</span>
									<div class="questionTitle_more questionTitle_more2" @click="collectionDelete(item)"><i class="el-icon-star-off"></i> 取消收藏</div>
									<div class="questionTitle_more" @click="viewMooc(item)"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="content-coursefoot" style="text-align:center">
							<el-pagination background @current-change="moocChange" :current-page="moocPage" :page-size="pageSize" layout="  prev, pager, next" :total="moocTotal">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="在线作业" name='second'>
						<div class="noinfo" v-if='taskList.length<=0'>暂无收藏</div>
						<div v-for="(item,index) in taskList">
							<div class="table-wrap single">
								<div class="questionTitle questionTitle_only">
									{{index+1}}、{{item.name}}
									<span style="margin-left:50px;font-weight:normal">收藏时间:{{item.createTime}}</span>
									<div class="questionTitle_more questionTitle_more2" @click="collectionDelete(item)"><i class="el-icon-star-off"></i> 取消收藏</div>
									<div class="questionTitle_more" @click="viewTopic(item)"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="content-coursefoot" style="text-align:center">
							<el-pagination background @current-change="taskChange" :current-page="taskPage" :page-size="pageSize" layout="  prev, pager, next" :total="taskTotal">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="在线考试" name='third'>
						<div class="noinfo" v-if='examineList.length<=0'>暂无收藏</div>
						<div v-for="(item,index) in examineList">
							<div class="table-wrap single">
								<div class="questionTitle questionTitle_only">
									{{index+1}}、{{item.name}}
									<span style="margin-left:50px;font-weight:normal">收藏时间:{{item.createTime}}</span>
									<div class="questionTitle_more questionTitle_more2" @click="collectionDelete(item)"><i class="el-icon-star-off"></i> 取消收藏</div>
									<div class="questionTitle_more" @click="viewExamine(item)"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="content-coursefoot" style="text-align:center">
							<el-pagination background @current-change="examineChange" :current-page="examinePage" :page-size="pageSize" layout="  prev, pager, next" :total="examineTotal">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="仿真实验" name='four' v-if="false">
						<div class="noinfo" v-if='simulationList.length<=0'>暂无收藏</div>
						<div v-for="(item,index) in simulationList">
							<div class="table-wrap single">
								<div class="questionTitle questionTitle_only questionTitle_only2">
									{{index+1}}、{{item.name}}
									<span style="margin-left:50px;font-weight:normal">收藏时间:{{item.createTime}}</span>
									<div class="questionTitle_more questionTitle_more2" @click="collectionDelete(item)"><i class="el-icon-star-off"></i> 取消收藏</div>
									<div class="questionTitle_more" @click="viewSimulation(item)"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="content-coursefoot" style="text-align:center">
							<el-pagination background @current-change="simulationChange" :current-page="simulationPage" :page-size="pageSize" layout="  prev, pager, next" :total="simulationTotal">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<el-dialog title="查看详情" :visible.sync="viewDialog" width="850px" :close-on-click-modal="false">
			<div style="max-height: 500px;overflow-y: auto;padding:  10px;" class="hiddenScroll">
				<div v-for="(item,index) in viewlist">
					<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
						<div class="questionTitle questionTitle_info">
							{{index+1}}、
							<span v-if="item.topicType == 4">{{item.question | spliceQuestion}}</span>
							<span v-if="item.topicType != 4">{{item.question}}</span>
							<span class="maincolor">（<span v-if="item.topicType == it.value" v-for='it in types'>{{it.label}}题</span>）</span>
							<div v-if="item.isFile == '1'" class="filebox" style="margin: 20px 0 0 0;">
								<div class="fileboxname">图片/视频：</div>
								<div>
									<span :key='file.id' v-for="(file,fileindex) in item.files">
									<video style="width: 150px; height: 150px" :src="baseurl + file.url" v-if="file.url.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image fit="fill" style="width: 150px; height: 150px" :src="baseurl + file.url" :preview-src-list="[baseurl + file.url]" v-else>
									</el-image>
									</span>
								</div>
							</div>
						</div>
						<div v-if="item.topicType == 1">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div class="questionLabel questionLabel0">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br /><img :src="baseurl+it.value" alt="" />
										</span>
								</span>
							</div>
						</div>
						<div v-if="item.topicType == 2">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div class="questionLabel questionLabel0">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br /><img :src="baseurl+it.value" alt="" />
										</span>
								</span>
							</div>
						</div>
						<div v-if="item.topicType == 3">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div class="questionLabel questionLabel0">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br /><img :src="baseurl+it.value" alt="" />
										</span>
								</span>
							</div>
						</div>
						<div class="questionFooter" v-if="item.topicType == 1 || item.topicType == 2 || item.topicType == 3">
							我的答案：{{item.userAnswer}}&nbsp;&nbsp;
							<i class="iconfont iconcuo" v-if="item.chooseRight == '0'" style="color: #F56C6C;"></i>
							<i class="iconfont icondui" v-if="item.chooseRight == '1'" style="color: #00B43C;"></i>
						</div>
						<div class="questionFooter" v-if="item.topicType == 4">
							我的答案：{{item.userAnswer}}
						</div>
						<div class="questionFooter" v-if="item.topicType == 5">
							<div v-html="getAnswer(item)"></div>
						</div>
						<div class="fileArrbox" v-if="item.userAnswerFilearr && item.userAnswerFilearr.length>0">
							<div class="uploadFile" @click.stop="formPreview(file)" v-for="(file,index) in item.userAnswerFilearr">
								<img src="@/images/word.png" />
								<div class="p1">
									{{file.name}}
								</div>
								<div class="p2">
									{{file.size | filesize}}
								</div>
							</div>
							<div style="clear: both;"></div>
						</div>
						<div class="questionFooter" v-if="item.topicType == 4">
							参考答案：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
						</div>
						<div class="questionFooter" v-if="item.topicType != 4">
							参考答案：{{item.answer}}
						</div>
						<div class="questionFooter" v-if="item.topicType == 5">
							关键词：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
						</div>
						<div class="questionFooter">
							解析：{{item.analysis }}
						</div>
						<div class="questionFooter" v-show='item.comment'>
							教师评语：{{item.comment }}
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="viewDialog = false">确定</el-button>
			</div>
			<el-dialog :title="viewName==''?'预览':viewName" :visible.sync="viewShow" append-to-body>
				<div class="viewIframe" v-if="viewShow" v-loading="viewShowLoading">
					<iframe :src="playUrl" v-if="!viewAideoShow"  @load="viewShowLoading = false"></iframe>
					<audio :src="playUrl" v-if="viewAideoShow" controls="controls"></audio>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="viewShow = false">确定</el-button>
				</div>
			</el-dialog>
		</el-dialog>

	</div>
</template>

<script>
	import { downloadFile } from "@/utils/oss.js"
	import { collectionList, collectionDelete, collectionDetail } from '@/api/collection.js'
	import { getStorageToken } from '@/utils/auth'
	export default {
		data() {
			return {
				pageSize: 10,
				title: '',
				activeModel: 'first',

				//仿真实验
				simulationPage: 1,
				simulationTotal: 0,
				simulationList: [],

				//课程中心
				moocPage: 1,
				moocTotal: 0,
				mooclist: [],

				//在线考试
				examinePage: 1,
				examineTotal: 0,
				examineList: [],

				//在线考试
				taskPage: 1,
				taskTotal: 0,
				taskList: [],
				viewDialog: false,
				viewlist: [],
				types: [{
					value: '1',
					label: '单选'
				}, {
					value: '2',
					label: '多选'
				}, {
					value: '3',
					label: '判断'
				}, {
					value: '4',
					label: '填空'
				}, {
					value: '5',
					label: '简答'
				}],

				//文件
				playUrl: '',
				viewName: '',
				viewShowLoading: true,
				viewShow: false,
				viewAideoShow: false,
				viewopen: window.config.VUE_PDF_FILE,

			}
		},
		created() {
			this.getSimulationList();
			this.getMooc();
			this.getExamine();
			this.getTask();
		},
		methods: {
			getAnswer(item) {
				if(item.userAnswer) {
					var answerlist = item.answerlist;
					var answerStr = '我的答案：';
					var userAnswer = item.userAnswer;
					answerlist.map(answer => {
						userAnswer = userAnswer.split(answer.value).join('<span style="color: #e64242;">' + answer.value + '</span>');
					})
					return answerStr + userAnswer;
				} else {
					return '';
				}
			},
			formPreview(file) {
				var url = file.url;
				var fileUrl = url;
				var fileName = file.name;
				var filetype = file.url.substring(file.url.lastIndexOf('.') + 1);
				this.viewAideoShow = false;
				if(filetype == 'doc' || filetype == 'docx') {
					var playUrl = this.baseurl + url;
					playUrl = this.viewopen + encodeURIComponent(window.btoa(playUrl));
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					this.viewShowLoading = true;
				} else {
					var playUrl = this.baseurl + url;
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					if(filetype == 'mp3' || filetype == 'wav') {
						this.viewAideoShow = true;
					}
				}
			},
			taskChange(page) {
				this.taskPage = page;
				this.getTask()
			},
			getTask() {
				var data = {
					page: this.taskPage,
					pageSize: this.pageSize,
					type: "taskTopic"
				}
				collectionList(data).then(res => {
					this.taskList = res.data.listData;
					this.taskTotal = res.data.totalRow;
				})
			},
			simulationChange(page) {
				this.simulationPage = page;
				this.getSimulationList()
			},
			getSimulationList() {
				var data = {
					page: this.simulationPage,
					pageSize: this.pageSize,
					type: "simulation"
				}
				collectionList(data).then(res => {
					this.simulationList = res.data.listData;
					this.simulationTotal = res.data.totalRow;
				})
			},
			moocChange(page) {
				this.moocPage = page;
				this.getMooc()
			},
			getMooc() {
				var data = {
					pageSize: this.pageSize,
					page: this.moocPage,
					type: "mooc"
				}
				collectionList(data).then(res => {
					this.mooclist = res.data.listData;
					this.moocTotal = res.data.totalRow;
				})
			},
			examineChange(page) {
				this.examinePage = page;
				this.getExamine()
			},
			getExamine() {
				var data = {
					pageSize: this.pageSize,
					page: this.examinePage,
					type: "examine"
				}
				collectionList(data).then(res => {
					this.examineList = res.data.listData;
					this.examineTotal = res.data.totalRow;
				})
			},
			//取消收藏
			collectionDelete(item) {
				// collectionDelete
				this.$confirm('确定取消收藏?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					collectionDelete({
						id: item.id
					}).then(res => {
						if(res.success == true) {
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
						}
						this.getSimulationList();
						this.getMooc();
						this.getExamine();
						this.getTask();
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},

			//仿真实验页
			viewSimulation(item) {
				var token = getStorageToken();
				if(token) {
					window.localStorage.setItem('libId', item.typeId)
					window.open('#/fictitiousdetail?type=test')
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			//课程中心页
			viewMooc(item) {
				this.$router.push({
					name: 'courseindex',
					query: {
						id: item.typeId
					}
				})
			},
			//在线考试
			viewExamine(item) {
				this.$router.push({
					name: 'examdetails',
					query: {
						id: item.typeId
					}
				})
			},
			viewTask(item) {
				this.$router.push({
					name: 'taskdetails',
					query: {
						taskId: item.typeId
					}
				})
			},
			viewTopic(item) {
				var data = {
					typeId: item.typeId
				}
				collectionDetail(data).then(res => {
					this.topicInfo = res.data;
					this.openView(res.data)
				})
			},
			openView(item) {
				var question = Object.assign({}, item.userAnswers, item);
				if(question.isFile == 1 && question.fileName != null) {
					var files = JSON.parse(question.fileName);
					question.files = files;
				}
				if(question.topicType != 4 && question.topicType != 5) {
					if(!question.userAnswer) {
						question.choose = [];
					} else {
						question.choose = question.userAnswer.split('')
					}

					if(question.userScore && question.userScore > 0) {
						question.chooseRight = 1
					} else {
						question.chooseRight = 0
					}
				}
				if(question.topicType == 5 && question.userAnswerFile && question.userAnswerFile != '') {
					question.userAnswerFilearr = JSON.parse(question.userAnswerFile);
					question.userAnswerFile = question.userAnswerFile;
				}
				var answerlist = [];
				if(question.optionA != '' && question.optionA != null) {
					if(question.optionA.indexOf('@') == -1) {
						answerlist[0] = {
							type: '1',
							label: 'A',
							value: question.optionA,
						}
					} else {
						answerlist[0] = {
							type: '2',
							label: 'A',
							value: question.optionA.slice(1),
						}
					}
				}
				if(question.optionB != '' && question.optionB != null) {
					if(question.optionB.indexOf('@') == -1) {
						answerlist[1] = {
							type: '1',
							label: 'B',
							value: question.optionB,
						}
					} else {
						answerlist[1] = {
							type: '2',
							label: 'B',
							value: question.optionB.slice(1),
						}
					}
				}
				if(question.optionC != '' && question.optionC != null) {
					if(question.optionC.indexOf('@') == -1) {
						answerlist[2] = {
							type: '1',
							label: 'C',
							value: question.optionC,
						}
					} else {
						answerlist[2] = {
							type: '2',
							label: 'C',
							value: question.optionC.slice(1),
						}
					}
				}
				if(question.optionD != '' && question.optionD != null) {
					if(question.optionD.indexOf('@') == -1) {
						answerlist[3] = {
							type: '1',
							label: 'D',
							value: question.optionD,
						}
					} else {
						answerlist[3] = {
							type: '2',
							label: 'D',
							value: question.optionD.slice(1),
						}
					}
				}
				if(question.optionE != '' && question.optionE != null) {
					if(question.optionE.indexOf('@') == -1) {
						answerlist[4] = {
							type: '1',
							label: 'E',
							value: question.optionE,
						}
					} else {
						answerlist[4] = {
							type: '2',
							label: 'E',
							value: question.optionE.slice(1),
						}
					}
				}
				if(question.optionF != '' && question.optionF != null) {
					if(question.optionF.indexOf('@') == -1) {
						answerlist[5] = {
							type: '1',
							label: 'F',
							value: question.optionF,
						}
					} else {
						answerlist[5] = {
							type: '2',
							label: 'F',
							value: question.optionF.slice(1),
						}
					}
				}
				question.answerlist = answerlist;
				this.viewDialog = true;
				this.viewlist = [question];
			},

		}
	}
</script>

<style>

</style>